import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  container: {
    height: "90%",
    marginTop: "0px",
  },
  listContainer: {
    border: "1px solid #000000",
    borderRadius: "5px",
    height: "94%",
  },
  listItemBtn: {
    borderBottom: "1px solid black",
    transition: "none !important",
    "&:hover": {
      backgroundColor: "#BBBBBB",
    },
  },
  listItmBtnSelected: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
  },
  sublistItmBtnSelected: {
    backgroundColor: "#BBBBBB",
    color: "#000000",
  },
  listIcon: {
    minWidth: "45px",
  },
  tableRowHeadService: {
    width: "16.6%",
    padding: "8px",
  },
  tableRowCellsColor: {
    color: "#666666",
  },
  tableRowBorder: {
    borderBottom: "1px solid white",
  },
  tableRowHeadInvitation: {
    width: "25%",
  },
  centerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  commonLoader: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default useStyles;
